export const pipe = <T>(input: T, ...functions: Array<(v: T) => T>) =>
  functions.reduce((acc, func) => func(acc), input);
